module.exports = __webpack_public_path__ + "img/oilwell.9060cbb0.webp";